import { createTRPCClient, httpBatchLink, splitLink } from '@trpc/client';
import { type ApiRouter } from '../../server/apiRouter';

import _ from 'lodash';
import { RoleType } from '../../types/authTypes';
import firebaseStore from '../stores/firebaseStore';
import { createTrpcWithCache, WithTrpcCache } from './trpcWithCache';

const trpcClient = createTRPCClient<ApiRouter>({
    links: [
        splitLink({
            condition(op) {
                const path = op.path;

                // api 라우트의 주소를 보고 인증이 필요한 경우 토큰을 전송한다
                const rolePart = _.nth(_.split(path, '.'), 1) as RoleType | 'public';
                const needAuthHeader = rolePart !== 'public'; // 인증 헤더 필요 여부

                return needAuthHeader;
            },
            // 인증이 필요한 요청
            true: httpBatchLink({
                url: '/api',
                headers: async () => {
                    await firebaseStore.waitUntilAuthReady();

                    const idToken = await firebaseStore.getIdToken();
                    return {
                        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
                    };
                },
            }),
            // 공개 요청 (인증 불필요)
            false: httpBatchLink({
                url: '/api',
            }),
        }),
    ],
});

export const apiClient = createTrpcWithCache(trpcClient) as WithTrpcCache<typeof trpcClient>;
